const profileKeys = ["name", "email", "address", "phone", "type"];

export default {
    setUser(state, { user }) {
      state.user = user.data;
      // token is stored in localStorage by action; also reflect it in state
      state.token = user.data?.data?.token || localStorage.getItem("token");
  },
  // localStorage stays the source of truth for the profile fields; this mirrors it for reactive UI.
  syncProfile(state) {
    profileKeys.forEach((key) => {
      state[key] = localStorage.getItem(key);
    });
  },
  logout(state) {
    state.user = null;
    state.token = null;
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("address");
    localStorage.removeItem("phone");
    localStorage.removeItem("type");
    localStorage.removeItem("company_id");
    profileKeys.forEach((key) => {
      state[key] = null;
    });
  }
};
